module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanBadger_f_erythristic.5e79349d.png";